import React, { useMemo } from "react";
import { WithStyles, withStyles, FormControlLabel, FormControl, RadioGroup, Radio, Button, Typography, Box, Theme } from "@material-ui/core";
import { StyleRules } from "@material-ui/styles";
import Term from "components/term";
import { ITramite } from "gateways/tramites.interfaces";

const styles = (theme: Theme): StyleRules => ({
  select: {
    width: 230,
  },
  buttonList: {
    flex: 1,
    display: "flex",
    flexDirection: "row-reverse",
  },
  button: {
    width: 200,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    marginTop: 15,
    marginLeft: 10,
  },
  categoriesContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    paddingBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  categoryBlock: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: "2px",
  },
  categoryTitle: {
    marginBottom: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "small",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
  },
  radioLabel: {
    display: "flex",
    alignItems: "start",
    "& .MuiRadio-root": {
      paddingTop: "3px",
    },
    "& .MuiFormControlLabel-label": {
      paddingTop: "3px",
    },
  },
});

interface IProps extends WithStyles<typeof styles> {
  onChange: (value: any) => void;
  onSubmit: () => void;
  tramites: ITramite[];
  tramite: number;
}

const SeleccionTramite: React.FC<IProps> = ({ onChange, tramites, tramite, classes, onSubmit }) => {
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    if (typeof onChange === "function") {
      const values = event.target.value as any;
      onChange(parseInt(values, 10));
    }
  };

  const handleSubmit = () => {
    onSubmit();
  };

  const groupedTramites = useMemo(
    () =>
      tramites.reduce((acc, item) => {
        const category = item.nombreCategoria || "Sin categoría";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {} as Record<string, ITramite[]>),
    [tramites]
  );

  return (
    <>
      <FormControl component="fieldset" className={classes.form}>
        <RadioGroup aria-label="tramite" name="tramite" value={tramite} onChange={handleChange} className={classes.radioGroup}>
          <div className={classes.categoriesContainer}>
            {Object.entries(groupedTramites).map(([category, categoryTramites]) => (
              <div key={category} className={classes.categoryBlock}>
                <Typography variant="subtitle2" className={classes.categoryTitle}>
                  <Term component="Tramites" text={category} />
                </Typography>
                {categoryTramites.map((item) => (
                  <FormControlLabel
                    key={"tramite_" + item.id}
                    value={item.id}
                    className={classes.radioLabel}
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2">
                        <Term component="Tramites" text={item.nombre} />
                      </Typography>
                    }
                  />
                ))}
              </div>
            ))}
          </div>
        </RadioGroup>
        <div className={classes.buttonList}>
          <Button type="submit" variant="contained" size="small" className={classes.button} color="primary" onClick={handleSubmit} disabled={tramite === -1}>
            <Term component="Global" text="Continuar" />
          </Button>
        </div>
      </FormControl>
    </>
  );
};

export default withStyles(styles)(SeleccionTramite);
